<template>
  <fieldset class="account__form-section">
    <legend class="account__form-section-title">Change Password</legend>
    <div class="input-group__wrap">
      <div class="input-group__field-wrap">
        <label for="currentPassword" class="input-group__label"
          >Current Password</label
        >
        <input
          id="currentPassword"
          :type="hideOldPassword ? 'password' : 'text'"
          class="input-group__input"
          :class="{
            'input-group__input--error':
              $v.currentPassword.$invalid && $v.currentPassword.$dirty,
          }"
          v-model="currentPassword"
          @change="handleChange"
          aria-required="true"
          :aria-invalid="
            $v.currentPassword.$invalid && $v.currentPassword.$dirty
          "
        />
        <DisclosureButton
          target="currentPassword"
          :hide="hideOldPassword"
          :showAction="toggleShowOldPassword"
          :hideAction="toggleHideOldPassword"
        />
        <Error
          :invalid="!$v.currentPassword.required && $v.currentPassword.$dirty"
          message="Please enter the current password"
        />
        <Error
          :invalid="!isCurrentPasswordValid"
          message="The password you entered is incorrect"
        />
      </div>
      <div class="input-group__wrap">
        <div class="input-group__field-wrap">
          <label for="newPassword" class="input-group__label"
            >New Password</label
          >
          <input
            id="newPassword"
            :type="hidePassword ? 'password' : 'text'"
            class="input-group__input"
            :class="{
              'input-group__input--error':
                $v.newPassword.$invalid && $v.newPassword.$dirty,
            }"
            v-model="newPassword"
            @change="handleChange"
            aria-required="true"
            :aria-invalid="$v.newPassword.$invalid && $v.newPassword.$dirty"
          />
          <DisclosureButton
            target="newPassword"
            :hide="hidePassword"
            :showAction="toggleShowPassword"
            :hideAction="toggleHidePassword"
          />
          <Error
            :invalid="!$v.newPassword.required && $v.newPassword.$dirty"
            message="Please enter a new password"
          />
          <Error
            :invalid="!$v.newPassword.minLength && $v.newPassword.$dirty"
            message="Password needs to be at least 8 characters"
          />
        </div>
        <div class="input-group__field-wrap">
          <label for="reEnterNewPassword" class="input-group__label"
            >Re-Enter New Password</label
          >
          <input
            id="reEnterNewPassword"
            :type="hideRepeatPassword ? 'password' : 'text'"
            class="input-group__input"
            :class="{
              'input-group__input--error':
                $v.reEnterNewPassword.$invalid && $v.reEnterNewPassword.$dirty,
            }"
            v-model="reEnterNewPassword"
            @change="handleChange"
            aria-required="true"
            :aria-invalid="
              $v.reEnterNewPassword.$invalid && $v.reEnterNewPassword.$dirty
            "
          />
          <DisclosureButton
            target="reEnterNewPassword"
            :hide="hideRepeatPassword"
            :showAction="toggleShowRepeatPassword"
            :hideAction="toggleHideRepeatPassword"
          />
          <Error
            :invalid="
              !$v.reEnterNewPassword.required && $v.reEnterNewPassword.$dirty
            "
            message="Please re-enter the new password"
          />
          <Error
            :invalid="
              !$v.reEnterNewPassword.sameAsNewPassword &&
                $v.reEnterNewPassword.$dirty
            "
            message="Please make sure the two passwords match"
          />
        </div>
      </div>
    </div>
    <LoadingButton
      :event="saveNewPassword"
      :loading="$wait.is('saving password')"
      :doneLoading="saved"
      label="Change Password"
    />
  </fieldset>
</template>

<script>
import IconAlert from "../../../assets/icons/icon-alert.svg";

import { mapGetters } from "vuex";
import { mapWaitingActions } from "vue-wait";
import { required, sameAs, email, minLength } from "vuelidate/lib/validators";

import LoadingButton from "../../../components/LoadingButton";
import DisclosureButton from "../../../components/DisclosureButton";
import Error from "../../../components/Error";

import { helpers } from "vuelidate/lib/validators";

const formSection = "Change Password";

export default {
  name: "YourPassword",
  components: {
    LoadingButton,
    DisclosureButton,
    Error,
  },
  data() {
    return {
      currentPassword: "",
      newPassword: "",
      reEnterNewPassword: "",
      hidePassword: true,
      hideRepeatPassword: true,
      hideOldPassword: true,
      formSection,
      saved: false,
      isCurrentPasswordValid: true,
    };
  },
  computed: {
    ...mapGetters("account", ["data", "subscriptionData"]),
    ...mapGetters("forms", ["formSectionChanged"]),
  },
  methods: {
    ...mapWaitingActions("account", { savePassword: "saving password" }),
    saveNewPassword: function() {
      this.$v.currentPassword.$touch();
      this.$v.newPassword.$touch();
      this.$v.reEnterNewPassword.$touch();
      if (
        !this.$v.currentPassword.$invalid &&
        !this.$v.newPassword.$invalid &&
        !this.$v.reEnterNewPassword.$invalid
      ) {
        this.saved = false;
        this.savePassword({
          oldPassword: this.currentPassword,
          newPassword: this.newPassword,
        })
          .then(() => {
            this.$v.currentPassword.$reset();
            this.$v.newPassword.$reset();
            this.$v.reEnterNewPassword.$reset();
            this.$v.$reset();
            this.saved = true;
            this.isCurrentPasswordValid = true;
          })
          .catch((error, data) => {
            console.log("error", error);
            console.log("data", data);
            this.saved = false;
            this.isCurrentPasswordValid = false;
          });
      }
    },
    handleChange: function() {
      this.saved = false;
    },
    toggleHidePassword() {
      this.hidePassword = true;
    },
    toggleShowPassword() {
      this.hidePassword = false;
    },
    toggleHideRepeatPassword() {
      this.hideRepeatPassword = true;
    },
    toggleShowRepeatPassword() {
      this.hideRepeatPassword = false;
    },
    toggleHideOldPassword() {
      this.hideOldPassword = true;
    },
    toggleShowOldPassword() {
      this.hideOldPassword = false;
    },
  },
  validations: {
    currentPassword: {
      required,
    },
    newPassword: {
      required,
      minLength: minLength(8),
    },
    reEnterNewPassword: {
      required,
      sameAsNewPassword: sameAs("newPassword"),
    },
  },
};
</script>

<style></style>
